export default "/images/b6690fdc128d9eec61a0f6c26ee9f350.png";